module.exports = __webpack_public_path__ + "assets/amount.0dbe7492.svg";